import React from "react"
import InputMask from "react-input-mask";
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'
export default class Input extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      hidden: true
    }
    this.config = { 
      types : [
        {
          title: 'email', 
          type  : 'email',
          pattern : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        },
        {
          title: 'cep', 
          type  : 'zipcode', /* check type before use "title" */
          mask  : '99999 - 999',
          pattern : /^\d{5} - \d{3}$/,
        },
        {
          title: 'cpf',
          type  : 'text',
          mask  : '999.999.999-99',
          pattern : /^\d{3}\.\d{3}.\d{3}-\d{2}$/,
          fn : this.validateCpf
        },
        {
          title: 'cnpj',
          pattern : /^\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2}$/,
          value : /_| |-|\./g,
          fn : this.validateCNPJ
        },
        {
          title: 'cpf-cnpj',
          pattern : /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
          value : /_| |-|\./g,
          fn : [this.validateCpf, this.validateCNPJ]
        },
        {
          title: 'phone',
          type  : 'tel',
          mask  : ['(99) 9999 9999', '(99) 9 9999 9999']
        },
        { 
          title: 'text',
          type  : 'text'
        },
        { 
          title: 'email',
          type  : 'email',
          pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },
        { 
          title: 'number',
          type  : 'number'
        },
        { 
          title: 'password',
          type  : 'password',
          icons : [
            'mdn-Icon-ocultar',
            'mdn-Icon-exibir'
          ]
        },
        { 
          title: 'search',
          type  : 'search',
          icons : 'mdn-Icon-busca'
        },
        { 
          title: 'action',
          type  : 'email',
          icons : 'mdn-Icon-direita',
          pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },
        { 
          title: 'textarea'
        },
        { 
          title: 'select',
          type : 'select'
        }
      ]
    }
    this.toggleShow = this.toggleShow.bind(this)
    this.checkValues = this.checkValues.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  validateCNPJ(cnpj) {
    cnpj = cnpj.value || '';
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (
        cnpj === ''               || 
        cnpj.length !== 14        || 
        cnpj === '00000000000000' ||
        cnpj === '11111111111111' ||
        cnpj === '22222222222222' ||
        cnpj === '33333333333333' ||
        cnpj === '44444444444444' ||
        cnpj === '55555555555555' ||
        cnpj === '66666666666666' ||
        cnpj === '77777777777777' ||
        cnpj === '88888888888888' ||
        cnpj === '99999999999999'
    ) {
        return false;
    }
    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    const digits = cnpj.substring(length);
    let soma = 0;
    let pos = length - 7;
    for (let i = length; i >= 1; i--) {
      soma += numbers.charAt(length - i) * pos--;
      if (pos < 2) {
            pos = 9;
      }
    }
    let result = soma % 11 < 2 ? 0 : 11 - soma % 11;
    // tslint:disable-next-line: triple-equals
    if (result != digits.charAt(0)) {
        return false;
    }
    length = length + 1;
    numbers = cnpj.substring(0, length);
    soma = 0;
    pos = length - 7;
    for (let i = length; i >= 1; i--) {
      soma += numbers.charAt(length - i) * pos--;
      if (pos < 2) {
          pos = 9;
      }
    }
    result = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (result != digits.charAt(1)) {
          return false;
    }
    return true;
  }
  
  validateCpf(field, pattern) {
    let sum = 0, 
      rest, 
      strCPF = field.value.replace(/[\._\-]/g, '')
    if (
      strCPF == "00000000000" ||
      strCPF == "11111111111" ||
      strCPF == "22222222222" ||
      strCPF == "33333333333" ||
      strCPF == "44444444444" ||
      strCPF == "55555555555" ||
      strCPF == "66666666666" ||
      strCPF == "77777777777" ||
      strCPF == "88888888888" ||
      strCPF == "99999999999"
    ) return false;
    for (let i=1; i<=9; i++) sum = sum + parseInt(strCPF.substring(i-1, i)) * (11 - i);
    rest = (sum * 10) % 11;
    if ((rest == 10) || (rest == 11))  rest = 0;
    if (rest != parseInt(strCPF.substring(9, 10)) ) return false;
    sum = 0;
    for (let i = 1; i <= 10; i++) sum = sum + parseInt(strCPF.substring(i-1, i)) * (12 - i);
    rest = (sum * 10) % 11;
    if ((rest == 10) || (rest == 11))  rest = 0;
    if (rest != parseInt(strCPF.substring(10, 11) ) ) return false;
    return true;
  }

  toggleShow(evt) {
    evt && evt.preventDefault()
    this.setState({hidden: !this.state.hidden});
  }

  checkValues(event, props) {
    let target = event.target;
    let value = target.value;
    this.setState({value: value})

    if(target.required) {
      if(value.length == 0) {
        target.parentNode.classList.add('mdn-Input--attentionField')
      } else {
        callTestPatterns(this, target)
      }
    } else {
      if(value.length > 0 && (props.cep || props.cpf || props.phone)) {
        callTestPatterns(this, target)
      } else {
        target.parentNode.classList.remove('mdn-Input--attentionField')
      }
    }

    if(value.length > 0) {
      target.parentNode.classList.add('mdn-Input--activatedField')
    } else {
      target.parentNode.classList.remove('mdn-Input--activatedField')
    }

    function callTestPatterns(self, target) {
      if(self.testPatterns(target)) {
        target.parentNode.classList.remove('mdn-Input--attentionField')
      } else {
        target.parentNode.classList.add('mdn-Input--attentionField')
      }
    }

  }

  testPatterns(target) {
    const mdnType = target.dataset.mdnType || "text";
    const foundedConfig = this.config.types.find((configItem) => {
      return configItem.title === mdnType
    });
    const patternTestResult = foundedConfig.pattern ? foundedConfig.pattern.test(target.value) : true;
    const fnTestResult = foundedConfig.fn ? foundedConfig.fn(target, foundedConfig.pattern) : true;
    return patternTestResult && fnTestResult;
  }

  handleChange(event) {
    let { target } = event;
    this.checkValues && this.checkValues(event, this.props)
    const changeFn = this.props.onChange || (this.props.config && this.props.config.onChange)
    // changeFn && changeFn(event, target.value);
  }

  handleBlur() {
    let { target } = event;
    this.checkValues && this.checkValues(event, this.props)
    const blurFn = this.props.onBlur || (this.props.config && this.props.config.onBlur)
    blurFn && blurFn(event, target.value);
  }

  getInputType(props) { 
    let result = {}
    this.config.types.map((type) => {
      if(props[type.title]) { 
        result = type
      }
    })
    return result || {
      title: 'text'
    }
  }

  renderOptions(options){
    if(!options) return
    return options.map((option, index) =>
      <option key={index} value={option.value}>{option.label}</option>
    )
  }

  renderInputField(props, inputType) {
    const { options, ...selectProps } = props;
    const fields = {
      textarea: <textarea 
        {...props}
        className={'mdn-Input-field ' + (props.className || '') }
        data-mdn-type={inputType.title}
        onChange={this.handleChange} 
        onBlur={this.handleBlur}
        disabled={this.props.config && this.props.config.isDisabled || this.props.disabled}
      />,
      select: <select 
        {...selectProps}
        className={'mdn-Input-field ' + (props.className || '') }
        data-mdn-type={inputType.title}
        onChange={this.handleChange} 
        onBlur={this.handleBlur}
        disabled={this.props.config && this.props.config.isDisabled || this.props.disabled}>
          {this.renderOptions(props.options)}
      </select>,
      password: <input 
        {...props}  
        className={'mdn-Input-field ' + (props.className || '') }
        data-mdn-type={inputType.title}
        type={this.state.hidden ? "password" : "text"}
        required={props.required}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        disabled={this.props.config && this.props.config.isDisabled || this.props.disabled}
      />,
      action: <input 
        {...props}  
        className={'mdn-Input-field ' + (props.className || '') }
        data-mdn-type={inputType.title}
        type='text'
        required={props.required}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        disabled={this.props.config && this.props.config.isDisabled || this.props.disabled}
      />,
      default: <InputMask
        {...props}  
        className={'mdn-Input-field ' + (props.className || '') }
        data-mdn-type={inputType.title}
        type={inputType.type}
        mask={inputType.mask}
        required={props.required}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        disabled={this.props.config && this.props.config.isDisabled || this.props.disabled}
      />
    };
    return fields[inputType.title] || fields.default;
  }

  renderIcons(inputType) {
    let icons = Array.isArray(inputType.icons) ? inputType.icons : [inputType.icons];
    return icons.map((icon, index) => <span key={index} className={icon + ' mdn-Icon--md'}></span>);
  }

  render() {
    let { 
      children, 
      parentId,
      config,
      className,
      parentClassName,
      id,
      parentProps,
      options,
      errorMessage,
      ...rest } = this.props;

    const inputType = this.getInputType(rest);
    const clearedProps = clearProps(rest)
    return <div {...clearedProps} onBlur={this.props.parentOnBlur} id={parentId} className={resolveProps(rest, this.config, 'Input') + (this.props.value ? 'mdn-Input--activatedField' : '')  + ' ' + (parentClassName || '')} {...parentProps}>
      { this.renderInputField({
        ...clearedProps,
        className,
        id,
        options
      }, inputType) }
      <label htmlFor={id} className="mdn-Input-label">{children}</label>
      { inputType.icons ? <a href="#" className="mdn-Input-action" onClick={this.toggleShow}>
        { this.renderIcons(inputType) }
      </a> : null }
      <small className="mdn-Input-errorFeedback">{ errorMessage || 'Por favor, preencha este campo corretamente.' }</small>
    </div>
  }
}
Input.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  config: PropTypes.object,
  disabled: PropTypes.bool,
  action: PropTypes.bool,
}
